import MasterCrudPage from "../../components/MasterCrudPage";
import {
  serviceApi,
  userMasterApi,
  wishlistApi,
} from "../../api/masterApi";

function userLabel(user) {
  const name = [user.first_name, user.last_name].filter(Boolean).join(" ");
  return name || "User";
}

export default function Wishlist() {
  return (
    <MasterCrudPage
      title="Wishlist"
      description="Manage user wishlist items linked to assets."
      idKey="wishlist_id"
      api={wishlistApi}
      listLabel="wishlist items"
      useJson
      loadExtraOptions={async () => {
        const [users, assets] = await Promise.all([
          userMasterApi.list(),
          serviceApi.list(),
        ]);

        return {
          users: (users || []).map((user) => ({
            value: user.user_id,
            label: userLabel(user),
          })),
          assets: (assets || []).map((asset) => ({
            value: asset.service_id,
            label: asset.service_title || "Asset",
          })),
        };
      }}
      fields={[
        {
          name: "user_id",
          label: "User",
          type: "select",
          required: true,
          optionsKey: "users",
          placeholder: "Select user",
        },
        {
          name: "asset_id",
          label: "Asset",
          type: "select",
          required: true,
          optionsKey: "assets",
          placeholder: "Select asset",
        },
      ]}
      columns={[
        { key: "wishlist_id", label: "Wishlist ID" },
        {
          key: "user_id",
          label: "User",
          render: (item) =>
            [item.first_name, item.last_name].filter(Boolean).join(" ") || "—",
        },
        {
          key: "asset_id",
          label: "Asset",
          render: (item) => item.service_title || "—",
        },
        {
          key: "created_at",
          label: "Created Date",
          render: (item) =>
            item.created_at
              ? String(item.created_at).replace("T", " ").slice(0, 19)
              : "—",
        },
      ]}
    />
  );
}
